"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authz = exports.tiers = void 0;
require("./arrays");
const checks_1 = require("./checks");
const getters_1 = require("./getters");
const setters_1 = require("./setters");
exports.tiers = ["free", "basic", "pro", "teams", "business"];
const channels = ["alpha", "beta", "stable"];
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const authz = () => {
    const setTierForUser = async (userId, tier) => {
        await setters_1.set.tier(tier).for.user(userId);
    };
    const getTierForUser = async (userId) => {
        return await getters_1.get.tier.for.user(userId);
    };
    const setTierForOrganization = async (orgId, tier) => {
        await setters_1.set.tier(tier).for.organization(orgId);
    };
    const getTierForOrganization = async (orgId) => {
        return await getters_1.get.tier.for.organization(orgId);
    };
    const setChannelForUser = async (userId, channel) => {
        await setters_1.set.channel(channel).for.user(userId);
    };
    const getChannelForUser = async (userId) => {
        return await getters_1.get.channel.for.user(userId);
    };
    const setChannelForOrganization = async (orgId, channel) => {
        await setters_1.set.channel(channel).for.organization(orgId);
    };
    const getChannelForOrganization = async (orgId) => {
        return await getters_1.get.channel.for.organization(orgId);
    };
    const setTierForFeature = async (featureName, tier) => {
        await setters_1.set.tier(tier).for.feature(featureName);
    };
    const setChannelForFeature = async (featureName, channel) => {
        await setters_1.set.channel(channel).for.feature(featureName);
    };
    const getFeaturesOnTier = async (tier) => {
        return await getters_1.get.features.on.tier(tier);
    };
    const getFeaturesOnChannel = async (channel) => {
        return await getters_1.get.features.on.channel(channel);
    };
    const hasFeatureAccess = async (id, featureName) => {
        const [orgAccess, userAccess] = await Promise.all([
            hasOrgFeatureAccess(id, featureName),
            hasUserFeatureAccess(id, featureName),
        ]);
        return orgAccess || userAccess;
    };
    const hasUserFeatureAccess = async (userId, featureName) => {
        return await checks_1.checkIf.user(userId).can_access.feature(featureName);
    };
    const hasOrgFeatureAccess = async (orgId, featureName) => {
        return await checks_1.checkIf.organization(orgId).can_access.feature(featureName);
    };
    return {
        hasFeatureAccess,
        getTierForUser,
        setTierForUser,
        getTierForOrganization,
        setTierForOrganization,
        getChannelForUser,
        setChannelForUser,
        getChannelForOrganization,
        setChannelForOrganization,
        setTierForFeature,
        setChannelForFeature,
        getFeaturesOnTier,
        getFeaturesOnChannel,
        checkIf: checks_1.checkIf,
        set: setters_1.set,
        unset: setters_1.unset,
        get: getters_1.get,
    };
};
exports.Authz = authz();
//# sourceMappingURL=index.js.map